import * as THREE from 'three/build/three.module';
import { J3CameraUtils } from './J3CameraUtils';
export class J3DrawUtils extends EventTarget {


    constructor(public scene:THREE.scene) {
        // scene: Three.jsシーン
        super();
    }

    Update(cameraUtils:J3CameraUtils) {
        
    }

    DrawGrid(size = 100, divisions = 10, colorCenter = 0xffffff, colorGrid = 0xffffff, transparent = false, opacity = 1.0) {
        console.log('DrawGrid', size, divisions, colorCenter, colorGrid);
        const grid = new THREE.GridHelper(size, divisions, colorCenter, colorGrid);
        grid.material.transparent = transparent;
        grid.material.opacity = opacity;
        this.scene.add(grid);
    }

    DrawAxes(pos = [0, 0, 0], length = 10) {
        const axis = new THREE.AxesHelper(length);
        axis.position.set(pos[0], pos[1], pos[2]);
        this.scene.add(axis);
    }

}